var customerAnswers = {};

$( document ).ready(function() {
    let buttons = document.getElementsByClassName('quiz__option');
  	let backButtons = document.getElementsByClassName('back-btn');
  	let scrollArrows = document.getElementsByClassName('scroll-arrow');
  
    for (let button of buttons){
      button.addEventListener('click', function(){
        
        if(this.getAttribute('data-type') === 'answer'){		
          	addAnswer(button);
          	nextScreen(button);
        }
      });
    }
  
  	for (let backBtn of backButtons){
      backBtn.addEventListener('click', function(){
       
        if(this.getAttribute('data-type') === 'back'){
          	backScreen(backBtn)
        }
      });
    }

	for (let arrow of scrollArrows){
      arrow.addEventListener('click', function(){
      	scrollArrow(arrow)
      });
    }
});

function addAnswer(button){
  	let question = button.dataset.current;
	let answer = button.dataset.answer;
  	customerAnswers[question] = (answer);
}

function nextScreen(button){
	let currentId = button.dataset.current;
  	let nextId = button.dataset.next;
  	let screen = document.getElementById(nextId);
  
  	if (nextId == 'last'){
  		answerScreen()
  	}	
  	
  	screen.style.left = '0px';
  	$('body').animate({ scrollTop: 100 }, 1000);
  	setTimeout(() => {changePosition(currentId, nextId);}, 500)
}

function backScreen(button){
	let currentId = button.dataset.current;
  	let nextId = button.dataset.next;
  	let screen = document.getElementById(currentId);
  
  	screen.style.left = '-9999px';
  	$('body').animate({ scrollTop: 100 }, 1000);
  	changePosition(currentId, nextId)
}

function answerScreen(){
  let answer1 = customerAnswers.q1;

  let answerContainer = document.getElementById('answer');
  
  answerContainer.innerHTML = answers[answer1]
}

function changePosition(current, next){
	let currentId = current;
  	let nextId = next;
  	
  	let currentScreen = document.getElementById(currentId)
    let nextScreen = document.getElementById(nextId)
    
    nextScreen.style.position = 'relative'
    currentScreen.style.position = 'absolute'
    
}

//Arrow functions
function scrollArrow (button){
  	let target = button.getAttribute("data-target");
  	let direction = button.getAttribute("data-direction");
  	let speed = parseInt(button.getAttribute("data-speed"));
  	let distance = parseInt(button.getAttribute("data-distance"));
  	let step = parseInt(button.getAttribute("data-step"));
	let container = document.getElementsByClassName(target)[0];
  
  	sideScroll(container,direction,speed,distance,step);
}

function sideScroll(element,direction,speed,distance,step){
    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}  